import Prenotazioni from "../";

const routes = [{ name: "Agenda", path: "/agendeappuntamenti", component: Prenotazioni.PrenotazioniPage, meta: { title: "Agenda di Prenotazioni" } }];

export default routes;
